import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Hello, World!</h1>
        <p>Welcome to my React app.</p>
      </header>
    </div>
  );
}

export default App;
